import { render, staticRenderFns } from "./kw_medal.vue?vue&type=template&id=260bfa8a&scoped=true&"
import script from "./kw_medal.vue?vue&type=script&lang=js&"
export * from "./kw_medal.vue?vue&type=script&lang=js&"
import style0 from "./kw_medal.vue?vue&type=style&index=0&id=260bfa8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260bfa8a",
  null
  
)

component.options.__file = "kw_medal.vue"
export default component.exports